import { AppBar, Box, Dialog, styled, TableCell, TableContainer, Toolbar, Typography } from "@mui/material";
import { ReactComponent as MagicBotLogo } from '../assets/logo.svg';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
    position: 'fixed',
    height: '65px',
    width: '100%',
    backgroundColor: '#1C1D2B',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}));

export const StyledMagicBotLogo = styled(MagicBotLogo)(({ theme }) => ({
    width: '40px',
    height: 'auto',
    cursor: 'pointer'
}));

export const CenteredContainer = styled('main')(({ theme }) => ({
    gap: '2rem',
    [theme.breakpoints.up('md')]: {
        marginLeft: '212px',
        width: 'calc(100% - 212px)'
    }
}));

export const TypographyEllipsisStyled = styled(Typography)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '140px'
});

export const StyledContainerLoginPasswordPage = styled('main')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3rem',
    marginTop: '1rem',
    width: '100%',
    height: '80vh',
});

export const StyledFormLoginPasswordPage = styled('form')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
    width: '70%',
    [theme.breakpoints.up('sm')]: {
        width: '30%',
    }
}))

export const StyledDialogUserServer = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        backgroundColor: '#1C1D2B',
        borderRadius: '10px',
        padding: '0.5rem',
        width: '500px',
        maxWidth: '90%',
        [theme.breakpoints.up('md')]: {
            margin: '0px',
            marginLeft: '212px',
            maxWidth: '60%',
        }
    }
}));

export const StyledBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
});

export const StyledTableContainerServersUsersManagement = styled(TableContainer)(({ theme }) => ({
    background: 'linear-gradient(to top right, #CDC7E5 0%, #A92FFB 28%, #891CFB 59%, #2F27CE 100%)',
    padding: '2px',
    borderRadius: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        maxWidth: '75%',
    },
    [theme.breakpoints.between('md', 1100)]: {
        maxWidth: '90%',
    },
}));

export const StyledTableCellServerVersionPage = styled(TableCell)({
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
});

export const StyledButtonCancelSubmit = styled(Box)({
    display: 'flex',
    gap: '1rem',
    width: '100%',
    marginTop: '1rem',
})
